{"rating":"4.9","reviewCount":"141","fetchedAt":"2026-10-17T13:34:27.867Z","source":"place-details"}